
export enum SelectionStrategyType {

    SelectFirstLeafIfOnlyOne = "SelectFirstLeafIfOnlyOne",

    SelectAll = "SelectAll"
}
